<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <div class="welcome-message">
          <h3>
            Bienvenido {{ nombreCompleto }}<br>
            SAT Regional {{ nombreRegional }}
          </h3>
        </div>
      </div>


      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33">
        <chart-card :chart-data="dailySalesChart.data" :chart-options="dailySalesChart.options" :chart-type="'Line'"
          data-background-color="blue">
          <template slot="content">
            <div class="clickable-card" @click="$router.push({ name: 'Crear' })" style="cursor:pointer;">
              <h4 class="title">Registrar Datos</h4>
              <p class="category">
                <span class="text-success">
                  <i class="fas fa-long-arrow-alt-up"></i> 55%
                </span>
                Registros de datos.
              </p>
            </div>
          </template>
        </chart-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33">
        <chart-card :chart-data="emailsSubscriptionChart.data" :chart-options="emailsSubscriptionChart.options"
          :chart-responsive-options="emailsSubscriptionChart.responsiveOptions" :chart-type="'Bar'"
          data-background-color="red">
          <template slot="content">
            <div style="cursor:pointer" @click="$router.push({ name: 'Mostrar' })">
              <h4 class="title">Generar Reportes</h4>
              <p class="category">exportacion PDF</p>
            </div>
          </template>
        </chart-card>
      </div>

      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
        <stats-card data-background-color="green">
          <template slot="header">
            <md-icon>store</md-icon>
          </template>

          <template slot="content">
            <p class="category">
              Tipo de cambio actual USD/BOB:
              <span v-if="tipoCambio">{{ tipoCambio }}</span>
              <span v-else>Cargando...</span>
            </p>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>date_range</md-icon>
              Ultimas 24 Horas
            </div>
          </template>
        </stats-card>
      </div>

      <template v-if="rolUsuario === 'admin'">
        <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
          <stats-card data-background-color="red">
            <template slot="header">
              <md-icon class="md-warn">picture_as_pdf</md-icon>
            </template>
            <template slot="content">
              <div style="cursor:pointer" @click="mostrarModalReporte = true">
                <p class="category">Imprimir reporte mensual</p>

              </div>
            </template>
            <template slot="footer">
              <div class="stats">
                <md-icon>print</md-icon>
                PDF Reporte
              </div>
            </template>
          </stats-card>
        </div>
      </template>

      <ReporteMensualModal :visible="mostrarModalReporte" @generar="generarReportePDF"
        @close="mostrarModalReporte = false" />

      <template v-if="rolUsuario === 'admin'">
        <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
          <stats-card data-background-color="green">
            <template slot="header">
              <md-icon class="md-accent">grid_on</md-icon>
            </template>
            <template slot="content">
              <div style="cursor:pointer" @click="mostrarModalExcel = true">
                <p class="category">Exportar reporte mensual</p>
              </div>
            </template>
            <template slot="footer">
              <div class="stats">
                <md-icon>print</md-icon>
               Exel  Reporte
              </div>
            </template>
          </stats-card>
        </div>
      </template>

      <ModalExel :visible="mostrarModalExcel" @close="mostrarModalExcel = false" @generar="generarExcel" />

    </div>








  </div>
</template>

<script>
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ReporteMensualModal from '@/components/Modal/ReporteModal.vue';
import ModalExel from '@/components/Modal/ReporteMensualModal.vue';
import QRCode from "qrcode";
import { exportarSATExcel } from "../utils/exportarSATExcelJS";



import {
  StatsCard,
  ChartCard,
} from "@/components";

export default {
  components: {
    StatsCard,
    ChartCard,
    ReporteMensualModal,
    ModalExel
  },
  data() {
    return {
      // Inicializa rolUsuario como vacío, se llenará dinámicamente
      rolUsuario: '', // ¡CAMBIO CLAVE AQUÍ!
      mostrarModalReporte: false,
      mostrarModalExcel: false,
      regionalSeleccionada: null,
      fechaInicio: '',
      fechaFin: '',
      tipoCambio: null,
      regionales: [],
      dailySalesChart: {
        data: {
          labels: ["M", "T", "W", "T", "F", "S", "S"],
          series: [[12, 17, 7, 17, 23, 18, 38]],
        },
      },
      usuario: {}, // Asegúrate de que este objeto contenga la propiedad 'rol'
      dataCompletedTasksChart: {
        data: {
          labels: ["12am", "3pm", "6pm", "9pm", "12pm", "3am", "6am", "9am"],
          series: [[230, 750, 450, 300, 280, 240, 200, 190]],
        },

        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 0,
          }),
          low: 0,
          high: 1000,
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
      },
      emailsSubscriptionChart: {
        data: {
          labels: [
            "Ja", "Fe", "Ma", "Ap", "Mai", "Ju", "Jul", "Au", "Se", "Oc", "No", "De",
          ],
          series: [
            [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],
          ],
        },
        options: {
          axisX: {
            showGrid: false,
          },
          low: 0,
          high: 1000,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 0,
          },
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function (value) {
                  return value[0];
                },
              },
            },
          ],
        ],
      },
    };
  },
  computed: {
    nombreCompleto() {
      return `${this.usuario.nombre || ''} ${this.usuario.apellidos || ''}`.trim();
    },
    nombreRegional() {
      const regional = this.regionales.find(r => r.id == this.usuario.regional_id);
      return regional ? regional.nombre : 'Regional desconocida';
    }

  },

  methods: {
    convertImageToBase64(url) {
      return fetch(url)
        .then(response => response.blob())
        .then(
          blob =>
            new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            })
        );
    },
    async generarReportePDF({ regional_id, desde, hasta }) {
      const doc = new jsPDF();
      let yPos = 10;
      const logoUrl = '/fondotam.png';
      const tipoCambio = this.tipoCambio || 6.96;

      try {
        const logoBase64 = await this.convertImageToBase64(logoUrl);
        doc.addImage(logoBase64, "PNG", 12, 5, 25, 16);
      } catch (error) { }

      doc.setFontSize(12);
      doc.text("Reporte Mensual de Servicios", 60, yPos + 6);
      doc.setFontSize(10);
      doc.text(`Regional: ${this.regionales.find(r => r.id == regional_id)?.nombre || ''}`, 15, yPos + 14);
      doc.text(`Desde: ${desde}   Hasta: ${hasta}`, 15, yPos + 20);
      yPos += 28;

      let vuelos = [];
      try {
        const params = new URLSearchParams({ regional_id, desde, hasta });
        const res = await fetch(`https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/list/reporte_mensual.php?${params}`);
        vuelos = await res.json();
      } catch (e) {
        doc.text("No se pudo obtener la información.", 10, yPos);
        doc.save("reporte_mensual.pdf");
        return;
      }

      let globalTotal = 0;
      let resumenServicios = {};

      vuelos.forEach((vuelo, idx) => {
        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        doc.text(
          `N° Constancia: ${vuelo.numero_constancia}   N° Vuelo: ${vuelo.numero_vuelo}   Fecha: ${vuelo.fecha}   Regional: ${vuelo.regional}`,
          15, yPos
        );
        yPos += 5;
        doc.setFont("helvetica", "normal");

        const serviciosPorCategoria = {};
        vuelo.servicios.forEach(s => {
          if (!serviciosPorCategoria[s.categoria]) serviciosPorCategoria[s.categoria] = [];
          serviciosPorCategoria[s.categoria].push(s);

          const key = `${s.categoria}||${s.servicio}`;
          if (!resumenServicios[key]) {
            resumenServicios[key] = {
              categoria: s.categoria,
              servicio: s.servicio,
              total_constancias: 0,
              total_importe: 0
            };
          }
          resumenServicios[key].total_constancias += Number(s.constancias);
          resumenServicios[key].total_importe += Number(s.total);
        });

        Object.keys(serviciosPorCategoria).forEach(category => {
          const rows = serviciosPorCategoria[category].map(serv => [
            serv.servicio,
            serv.valor_unitario,
            serv.constancias,
            serv.total,
            (serv.total * tipoCambio).toFixed(2),
            serv.observaciones
          ]);
          const header = [category, "Importe Contrato", "Constancias", "Importe $", "Importe Bs", "Observaciones"];
          autoTable(doc, {
            head: [header],
            body: rows,
            startY: yPos,
            theme: "grid",
            styles: { fontSize: 8, cellPadding: 1 },
            headStyles: { fillColor: [0, 123, 255], textColor: [255, 255, 255] }
          });
          yPos = doc.lastAutoTable.finalY + 5;
        });

        let vueloTotal = vuelo.servicios.reduce((acc, s) => acc + Number(s.total), 0);
        globalTotal += vueloTotal;
        doc.text(`Total vuelo: $${vueloTotal.toFixed(2)} | Bs ${(vueloTotal * tipoCambio).toFixed(2)}`, 120, yPos);
        yPos += 10;

        if (yPos > 250 && idx < vuelos.length - 1) {
          doc.addPage();
          yPos = 10;
        }
      });

      if (yPos > 200) {
        doc.addPage();
        yPos = 10;
      }

      doc.setFontSize(12);
      doc.text("RESUMEN MENSUAL POR SERVICIO", 60, yPos + 6);
      yPos += 12;

      const resumenPorCategoria = {};
      Object.values(resumenServicios).forEach(s => {
        if (!resumenPorCategoria[s.categoria]) resumenPorCategoria[s.categoria] = [];
        resumenPorCategoria[s.categoria].push(s);
      });

      let totalGeneral = 0;

      Object.keys(resumenPorCategoria).forEach(category => {
        const rows = resumenPorCategoria[category].map(serv => [
          serv.servicio,
          serv.total_constancias,
          serv.total_importe.toFixed(2),
          (serv.total_importe * tipoCambio).toFixed(2)
        ]);
        totalGeneral += resumenPorCategoria[category].reduce((acc, serv) => acc + serv.total_importe, 0);

        autoTable(doc, {
          head: [[category, "Total Constancias", "Total $", "Total Bs"]],
          body: rows,
          startY: yPos,
          theme: "grid",
          styles: { fontSize: 8, cellPadding: 1 },
          headStyles: { fillColor: [0, 123, 255], textColor: [255, 255, 255] }
        });
        yPos = doc.lastAutoTable.finalY + 1;
      });

      doc.setFontSize(12);
      doc.text(`TOTAL GENERAL: $${totalGeneral.toFixed(2)} | Bs ${(totalGeneral * tipoCambio).toFixed(2)}`, 110, yPos + 10);

      // QR - datos del usuario
      let usuario = {};
      try {
        usuario = JSON.parse(localStorage.getItem("usuario")) || {};
      } catch (e) {
        console.warn("Error al parsear usuario:", e);// eslint-disable-line no-console
      }

      const now = new Date();
      const fecha = now.toLocaleDateString('es-BO');
      const hora = now.toLocaleTimeString('es-BO', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });

      const horaImpresion = `${hora} - ${fecha}`;
      const nombreUsuario = usuario?.nombre || 'Desconocido';
      const regionalTexto = this.regionales.find(r => r.id == regional_id)?.nombre || 'Regional no definida';

      const textoQR = `Documento generado por:
Nombre: ${nombreUsuario}
Regional: ${regionalTexto}
Hora: ${horaImpresion}`;

      try {
        const qrDataURL = await QRCode.toDataURL(textoQR, {
          width: 200,
          margin: 1
        });

        const qrSize = 25;
        const margin = 10;

        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        const qrX = margin;
        const qrY = pageHeight - qrSize - margin;
        doc.setFontSize(8);
        doc.text("Documento generado por:", qrX, qrY - 2);
        doc.addImage(qrDataURL, "PNG", qrX, qrY, qrSize, qrSize);
      } catch (qrError) {
        console.error("Error al generar QR:", qrError);// eslint-disable-line no-console
        doc.setFontSize(8);
        doc.text("QR no disponible", 10, doc.internal.pageSize.height - 10);
      }

      doc.save("reporte_mensual.pdf");
    },
    async generarExcel({ regional_id, desde, hasta }) {
      if (!regional_id || !desde || !hasta) {
        alert("Debe seleccionar regional y rango de fechas para generar el Excel.");
        return;
      }

      const params = new URLSearchParams({
        regional_id,
        desde,
        hasta
      });

      try {
        const response = await fetch(`https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/report/report_mensual_exel.php?${params}`);
        if (!response.ok) {
          throw new Error("Error en la petición al servidor");
        }
        const json = await response.json();

        if (json.vuelos && json.servicios_fijos) {
          const nombreArchivoDinamico = `SAT_Regional_${regional_id}_${desde}_${hasta}.xlsx`;
          await exportarSATExcel(json.vuelos, json.servicios_fijos, nombreArchivoDinamico);
        } else {
          alert("No se pudo generar el Excel, datos incompletos.");
        }
      } catch (error) {
        alert("Error al generar Excel: " + error.message);
      }
    },


    async obtenerTipoCambio() {
      try {
        const res = await fetch('https://open.er-api.com/v6/latest/USD');
        const data = await res.json();
        if (data.result === "success" && data.rates && data.rates.BOB) {
          this.tipoCambio = data.rates.BOB;
        } else {
          this.tipoCambio = "No disponible";
        }
      } catch (e) {
        this.tipoCambio = "No disponible";
      }
    },
    async obtenerRegionales() {
      const token = localStorage.getItem("authToken");
      try {
        const res = await fetch('https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/regional/listar_regionales.php', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        if (!res.ok) {
          const errorData = await res.json();
          throw new Error(errorData.message || 'Error al cargar regionales');
        }
        this.regionales = await res.json();
      } catch (e) {
        console.error('Error al cargar regionales:', e.message);// eslint-disable-line no-console
      }
    }
  },
  async mounted() {
    const userData = localStorage.getItem("usuario");
    if (userData) {
      this.usuario = JSON.parse(userData);
      // Asignar el rol del usuario de localStorage a rolUsuario
      if (this.usuario && this.usuario.rol) {
        this.rolUsuario = this.usuario.rol;
      }
    }
    await this.obtenerRegionales();
    this.obtenerTipoCambio();
  }

};
</script>
<style>
.welcome-message {
  margin-top: -35px;
  margin-bottom: 20px;
  text-align: center;
  background-color: #e3f2fd;
  padding: 15px;
  border-radius: 8px;
  color: #0d47a1;
  font-weight: bold;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
</style>
<style>
.welcome-message {
  margin-top: -35px;
  margin-bottom: 20px;
  text-align: center;
  background-color: #e3f2fd;
  padding: 15px;
  border-radius: 8px;
  color: #0d47a1;
  font-weight: bold;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.stats-card,
.stats-card .md-card,
.md-layout-item > .stats-card {
  transition: box-shadow 0.3s cubic-bezier(.4,0,.2,1), transform 0.3s cubic-bezier(.4,0,.2,1);
}
.stats-card:hover,
.stats-card .md-card:hover,
.md-layout-item > .stats-card:hover {
  box-shadow: 0 8px 32px rgba(44,62,80,0.18);
  transform: translateY(-4px) scale(1.03);
}

.stats-card .stats,
.stats-card .category,
.stats-card .title {
  transition: color 0.2s;
}

.stats-card .stats:hover,
.stats-card .category:hover,
.stats-card .title:hover {
  color: #1565c0;
}

.stats-card .md-icon {
  transition: transform 0.3s, color 0.2s;
}

.stats-card .md-icon:hover {
  transform: scale(1.2) rotate(-8deg);
  color: #ff9800 !important;
}

/* Opcional: animación de entrada para las tarjetas */
.md-layout-item {
  opacity: 0;
  transform: translateY(30px);
  animation: fadeInUp 0.7s cubic-bezier(.4,0,.2,1) forwards;
}
.md-layout-item:nth-child(2) { animation-delay: 0.1s; }
.md-layout-item:nth-child(3) { animation-delay: 0.2s; }
.md-layout-item:nth-child(4) { animation-delay: 0.3s; }
.md-layout-item:nth-child(5) { animation-delay: 0.4s; }
.md-layout-item:nth-child(6) { animation-delay: 0.5s; }

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: none;
  }
}
</style>
